import { render, staticRenderFns } from "./ExplanationItem.vue?vue&type=template&id=2f64334b&"
import script from "./ExplanationItem.vue?vue&type=script&lang=ts&"
export * from "./ExplanationItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports